import { getDepartamentos, createPedido, getUltimoPedido } from "//supercolonial.com/cdn/shop/t/4/assets/firebase-queries.js?v=49309244528855372491781324595";

export async function loadDepartamentos() {
    const departaments = await getDepartamentos();
    const departamentosSanitized = departaments
        .map(e => ({ ...e, Instrucciones: (e.Instrucciones || "").split("\\n").join("\n") }))
        .sort((a, b) => (a.OrderId ?? 0) - (b.OrderId ?? 0));
    return departamentosSanitized;
}

export async function submitPedido(pedido) {
    await createPedido(pedido);
}

export async function fetchUltimoPedido() {
    return await getUltimoPedido();
}
